import axios from "axios";
import React, { useRef, useState } from "react";
import { Accordion, Button, CloseButton, Col, Form, InputGroup, Modal, Row } from "react-bootstrap";
import toast from "react-hot-toast";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { FaPhone, FaQuestion, FaWhatsapp } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { useNavigate } from "react-router";
import b2bForumFlowChart from '../../../assets/b2bImages/b2bForumFlowChart.png';
import userRegisterQr from '../../../assets/b2bImages/userRegisterQr.png';
import RegisterNow from '../../../assets/headerImgs/RegisterNow.png';
import ContactTable from "../../../components/b2b/ContactTable";
import OurPresence from "../../../components/b2b/OurPresence";
import EPlatformHeader from "../../../components/basic/EPlatformHeader";
import Layout from "../../../components/Layouts/Layouts/Layout";
import { industries } from "../../../store/AllListData";
import { getURLbyEndPointV2 } from "../../../store/api";
import { country_list } from "../../auth/Register/AllRegiPageLists";
import "../../auth/Register/Register.css";

export const Profession = [
    "Mentor",
    "Lawyer",
    "Accountant",
    "Arbitrator Center",
    "New Market consultant",
    "Financial Adviser",
    'ADR PROFESSIONAL',
    "Chartered Accountant",
    "Company Secretary",
    "Export Adviser",
    "Commercial Adviser",
    "Innovation Adviser",
    "Digital Service Specialist",
    "Marketing Specialist",
    "Other",
];


const B2BEventBookings = () => {
    const [validated, setValidated] = useState(false);
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [formSuccessful, setFormSuccessful] = useState(false);
    const navigate = useNavigate();
    const [showFaqModal, setShowFaqModal] = useState(false);
    const [showWorkingModal, setShowWorkingModal] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const checkboxRef = useRef(null);

    const handleShow = () => setShowModal(true);
    const handleClose = () => setShowModal(false);
    const handleShowFaq = () => setShowFaqModal(true);
    const handleCloseFaq = () => setShowFaqModal(false);
    const handleShowWorking = () => setShowWorkingModal(true);
    const handleCloseWorking = () => setShowWorkingModal(false);
    const initialFormData = {
        title: '',
        firstName: '',
        surName: '',
        companyName: '',
        email: '',
        businessCategory: '',
        phoneNo: '',
        inputNumber: '',
        gstNo: '',
        address1: '',
        address2: '',
        country: '',
        city: '',
        state: '',
        pinCode: '',
        password: "",
    };
    const [formData, setFormData] = useState(initialFormData);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleConfirmChange = (e) => {
        const { value } = e.target;
        setConfirmPassword(value);
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const toggleConfirmPasswordVisibility = () => {
        setShowConfirmPassword(!showConfirmPassword);
    };

    const handleAgree = () => {
        setIsChecked(true);
        if (checkboxRef.current) {
            checkboxRef.current.checked = true;
        }
        handleClose();
    };

    const resetForm = () => {
        setFormData(initialFormData);
        setFormSuccessful(false);
        setValidated(false);
        setIsChecked(false);
    };

    const handleRegiFormSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;

        if (form.checkValidity() === false || formData.password !== confirmPassword) {
            event.stopPropagation();
            setValidated(true);
            return;
        }
        setFormSuccessful(true);

        try {
            const submissionData = {
                personalDetails: formData,
            };

            const res = await axios.post(
                getURLbyEndPointV2("createB2bUserRegistration"),
                { submissionData }
            );

            if (res && res.data && res.data.status) {
                toast.success(res.data.message);
                setFormSuccessful(false);
                setTimeout(() => {
                    navigate('/login');
                }, 5000);
            } else {
                toast.error(res?.data?.message || "An error occurred");
                setFormSuccessful(false);
            }
        } catch (e) {
            toast.error(e?.response?.data?.message || "An error occurred");
            setFormSuccessful(false);
        }
    };

    return (
        <>
            <Layout>
                <EPlatformHeader
                    heading="Book Your Slot - Virtual B2B Forum"
                    sideImg={RegisterNow}
                />
                <div className="custom-width mx-auto my-3">
                    <Row className="mt-2 ">
                        <Col sm={12} lg={6}>
                            <div className="content-section">
                                <div className="fw-bold fs-5">
                                    Do you find this important but ‘too-costly’ to fly abroad for exploring business opportunities?
                                </div>
                                <div className="fw-bold fs-6 mt-2">
                                    ‘Virtual B2B Forum’ is back with its initiative of making you meet our global collaborators at the comfort of your business.
                                </div>
                                <div className="fw-bold my-2 fs-6">
                                    Being your trade association, we understand the complexities of business, necessities to expand, and limitations to spend. To help you overcome such challenges, we have collaborated with 35+ global collaborators from the prominent trade partner countries: Germany, Nigeria, Vietnam, Kenya, Oman, Brazil, Egypt, and many more.
                                </div>
                                <div className="fw-bold mt-2">
                                    With this, AECCI marks its presence in 35+ countries. To make your global business journey an enriching experience, we are bringing back the “Virtual Business Forum” with opportunities to have “one-to-one 30-minute interaction sessions” with our collaborative expert partners.
                                </div>
                                <div className="fw-bold mt-4 mb-2">Under the initiative, you can meet our collaborators from the listed countries.</div>
                                <div>
                                    Prioritizing your trade requirements, we are keeping the B2B platform open and displaying the available collaborators along with their preferred meeting slots. By logging into the B2B platform, you can view and request appointments for your chosen countries.
                                </div>
                                <div className="fw-bold mt-4 mb-2">The B2B initiative will support your business expansion and address all your concerns.
                                    We encourage you to explore the opportunities and seek advice on your trade queries, such as:
                                </div>
                                <ul>
                                    <li>Reaching new customers</li>
                                    <li>Business expansion</li>
                                    <li>Credibility checks of trade partners</li>
                                    <li>Compliances and regulations in foreign lands</li>
                                    <li>Product or brand registrations in the chosen country</li>
                                    <li>Resolving commercial disputes</li>
                                    <li>Seeking investment partners</li>
                                    <li>Fulfilling IPR needs</li>
                                    <li>And other such issues</li>
                                </ul>
                                <h6 className="my-3 text-justify fw-semibold">
                                    join us for the big initiative, and avail the opportunity to connect with the right source to reach to your potential market.
                                </h6>

                                <div className="mt-4">
                                    <h5 className="fw-semibold mt-4">If you need any further assistance, feel free to contact our B2B team at:</h5>
                                    <Row className="mt-3">
                                        <Col md={4} xs={12} className="text-center">
                                            <div className='flex flex-col d-none d-md-block'>
                                                <img src={userRegisterQr} className="img-fluid w-75 mt-3" alt="Register QR" />
                                                <Button onClick={handleShowFaq} variant="outline-info" className='mt-2'>Read FAQs <FaQuestion /></Button>
                                            </div>
                                        </Col>
                                        <Col md={8} xs={12}>
                                            <div className="d-flex align-items-start gap-2 my-2">
                                                <div>
                                                    <strong>Virtual B2B Forum Sales & Marketing Head</strong>
                                                    <div className="fw-semibold">Executive Director - Mrs. Swarn Dhiman </div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start gap-2 my-2">
                                                <FaWhatsapp size={20} />
                                                <div className="fw-semibold">
                                                    WhatsApp: <a href="https://wa.me/918433720996" className="text-decoration-none">+91-8433720996</a>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start gap-2 my-2">
                                                <FaPhone size={20} style={{ transform: "rotate(90deg)" }} />
                                                <div className="fw-semibold">
                                                    Board lines: <a href="tel:+912241271145" className="text-decoration-none">+91-22-41271145 | 46 | 47</a>
                                                </div>
                                            </div>

                                            <div className="d-flex align-items-start gap-2 my-2">
                                                <MdEmail size={20} />
                                                <div className="fw-semibold">
                                                    Email: <a href="mailto:ed@aecci.org.in" className="text-decoration-none">ed@aecci.org.in</a>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-start gap-2 my-2">
                                                <div className="fw-semibold">
                                                    Monday – Friday: 9.30 am – 6.30 pm*<br />
                                                    Saturday – 9.30 am – 3.30 pm* (IST)<br />
                                                </div>

                                                {/* Modal for FAQ */}
                                                <Modal show={showFaqModal} onHide={handleCloseFaq} size="xl" centered>
                                                    <Modal.Header
                                                        style={{ backgroundColor: "#0b3b5d", color: "white" }}
                                                        className="text-white text-center"
                                                    >
                                                        <Modal.Title className='text-center'>
                                                            FAQs for Participants
                                                        </Modal.Title>
                                                        <CloseButton variant="white" onClick={() => handleCloseFaq} />
                                                    </Modal.Header>
                                                    <Modal.Body style={{ maxHeight: '500px', overflowY: 'auto', padding: "20px" }}>
                                                        <div style={{ fontFamily: "Arial, sans-serif", lineHeight: "1.8", fontSize: "1rem", color: "#333" }}>

                                                            {/* General Section */}
                                                            <h4 style={{ color: "#34495e", marginBottom: "15px" }}><strong>General</strong></h4>
                                                            <Accordion >
                                                                <Accordion.Item eventKey="1">
                                                                    <Accordion.Header>
                                                                        <strong>What is Virtual B2B Forum ?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        The Virtual B2B Forum is an online platform designed to connect expert collaborators from around the world with Indian business owners, facilitating meaningful business discussions and opportunities for both sides.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="2">
                                                                    <Accordion.Header>
                                                                        <strong>What is the mission of the Virtual B2B Forum?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        The mission of the Virtual B2B Forum is to support Indian businesses in their expansion plans by removing the barriers like costly foreign trips, expensive trade expos, and uncertainty of foreign markets. Virtual B2B Forum connects businesses with trusted experts, where they can get the basic guidance needed to execute their expansion plans effectively.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="3">
                                                                    <Accordion.Header>
                                                                        <strong>What is the expertise of Our Collaborators?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        Our collaborators are experts in trade and law within their respective countries. They are highly experienced consultants specializing in business formation, expansion, and strategy.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>

                                                            <hr style={{ borderTop: "2px solid #2c3e50", marginBottom: "20px" }} />

                                                            {/* Business Opportunities Section */}
                                                            <h4 style={{ color: "#34495e", marginBottom: "15px" }}><strong>Business Opportunities</strong></h4>
                                                            <Accordion>
                                                                <Accordion.Item eventKey="4">
                                                                    <Accordion.Header>
                                                                        <strong>How are collaborative partners selected for the platform?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        The B2B team carefully identifies and connects with experienced trade and law experts, evaluating their education, professional background, track record, and willingness to collaborate. To be listed as a collaborator on our platform, each expert must have in-depth knowledge of their home country's trade policies, practices, market needs, industry standards and regulatory requirements.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="5">
                                                                    <Accordion.Header>
                                                                        <strong>How do you keep things discreet?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        We understand the sensitivity of the information we handle and take every possible measure to maintain its confidentiality. Before onboarding any collaborator, we follow a thorough process that includes meetings, reviewing all relevant documents, and ensuring agreement on our terms and conditions. Only after this due diligence and signing the agreement do we gain the confidence to bring them on board.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="6">
                                                                    <Accordion.Header>
                                                                        <strong>How do you decide whether or not to approve a B2B meeting request?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        Each meeting request is carefully reviewed to identify businesses that are most likely to benefit from the opportunities offered by the Virtual B2B Forum. In some cases, when meeting slots with a specific country expert are unavailable, we may need to decline the request. In such cases, we recommend alternative experts or countries that we believe would be equally suitable for the business.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="7">
                                                                    <Accordion.Header>
                                                                        <strong>Who is responsible for controlling the B2B meetings?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        All business meetings facilitated through our Virtual B2B forum are managed and monitored by our B2B Team. While we do not directly participate in the discussions between experts and business participants, the team remains actively available throughout the meeting. The B2B Team is ready to provide any technical or other support needed to ensure the meeting runs smoothly and according to the given schedule.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="8">
                                                                    <Accordion.Header>
                                                                        <strong>How do I get an update on the status of my B2B meeting?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        Our Virtual B2B platform is designed for the convenience of both parties. Expert collaborators can provide multiple available time slots directly on the e-platform, and Indian participants can request appointments based on the available options. All details regarding your meeting schedule or other updates will be available in your digital account on our e-platform.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="9">
                                                                    <Accordion.Header>
                                                                        <strong>How much time is generally available for B2B Meeting and Disscussions?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        Each meeting on our Virtual B2B Forum is allocated a 30-minute slot. Video conferencing windows are opened in advance for audio-video testing, and the remaining 30 minutes are allocated for the discussion. You can consider this time as an introductory session with a trusted source, offering an opportunity to explore future business services with the collaborators.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="10">
                                                                    <Accordion.Header>
                                                                        <strong>How can I prepare to get the maximum outcome from the Virtual B2B meeting? What should I keep ready in advance?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        Our collaborative partners bring rich experience and expertise in their respective trade environments. To make the most of your meeting, we recommend preparing a list of key questions and keeping ready any supporting documents in digital format that you may need to share during the meeting. Instead of asking too many questions, concentrate on the core aspects of your business plan. Additionally, exchanging business cards at the end of the meeting is the right way to establish future connections.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="11">
                                                                    <Accordion.Header>
                                                                        <strong>I couldn’t find the country of my interest listed on the B2B platform. What can I do about it?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        If the country of your interest isn’t listed as a collaborator, please send your feedback with the country name to our B2B team. We will make sure to explore trusted experts and resources from that country and arrange a meeting for you
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="12">
                                                                    <Accordion.Header>
                                                                        <strong>What happens if the other side doesn’t want to cooperate during the Virtual meeting?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        While such situations are rare, if you come across a Collaborator who is passive or showing disinterest during the meeting, please send us your feedback. You can also request a meeting with an alternative country expert, and we will work to arrange a more suitable match for your needs.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="13">
                                                                    <Accordion.Header>
                                                                        <strong>I’ve changed my mind and no longer wish to continue with the B2B meeting. Can I ask to get a refund?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        Customer satisfaction is our top priority, and we always ensure to give you the best of our services. If you decide not to proceed with a meeting with a particular country expert, you can request an alternate meeting with another prospective country’s expert. Your funds will be kept secured with us and can be adjusted for a future meeting.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>

                                                                <Accordion.Item eventKey="14">
                                                                    <Accordion.Header>
                                                                        <strong>What happens if my B2B meeting didn’t succeed? Can I get a refund?</strong>
                                                                    </Accordion.Header>
                                                                    <Accordion.Body>
                                                                        While we make every effort to ensure successful meetings, there are times when outcomes may not meet expectations due to factors beyond our control. If the issue arises from an error on our end, we will adjust your funds for future meetings. However, if the problem is caused by technical issues on your side (such as internet connectivity, power failure, or delays in joining), we cannot offer a refund or adjustment. We recommend exchanging business cards with your meeting partner so you can explore further opportunities at a later time.
                                                                    </Accordion.Body>
                                                                </Accordion.Item>
                                                            </Accordion>

                                                            <hr style={{ borderTop: "2px solid #2c3e50", marginBottom: "20px" }} />

                                                            {/* Team Members Section */}
                                                            <h4 style={{ color: "#34495e", marginBottom: "15px" }} className='mt-4'><strong>Team Members</strong></h4>
                                                            <ContactTable />
                                                        </div>
                                                    </Modal.Body>
                                                    <Modal.Footer style={{ borderTop: "2px solid #ddd", padding: "15px 20px" }}>
                                                        <Button variant="secondary" size="sm" onClick={handleCloseFaq} >
                                                            Close
                                                        </Button>
                                                    </Modal.Footer>
                                                </Modal>
                                            </div>
                                            <div>
                                                <Button onClick={handleShowWorking} variant="outline-info" className='mt-2'>How it works </Button>

                                                {/* Modal for How it work */}
                                                <Modal show={showWorkingModal} onHide={handleCloseWorking} size="xl" centered>
                                                    <Modal.Header
                                                        style={{ backgroundColor: "#0b3b5d", color: "white" }}
                                                        className="text-white text-center"
                                                    >
                                                        <Modal.Title className='text-center'>
                                                            How it works
                                                        </Modal.Title>
                                                        <CloseButton variant="white" onClick={() => handleCloseWorking} />
                                                    </Modal.Header>
                                                    <Modal.Body>
                                                        <img src={b2bForumFlowChart}
                                                            alt="User Register QR"
                                                            className="img-fluid w-100"
                                                        />
                                                    </Modal.Body>
                                                </Modal>
                                            </div>

                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Col>
                        <Col sm={12} lg={6} >
                            <div style={{
                                background: "#021C43",
                                padding: "40px",
                            }}>
                                <Form noValidate validated={validated} onSubmit={handleRegiFormSubmit}>
                                    <div className="mb-3 mt-2">
                                        <>
                                            <div
                                                className="text-white montserratFont"
                                            >
                                                <p className="mt-3" style={{ fontSize: "0.9em" }}>
                                                    * indicates required fields
                                                </p>
                                                <Row className="mb-4">
                                                    <Col xs={12} sm={4} md={3}>
                                                        <Form.Group controlId="title">
                                                            <Form.Label className="fw-bold">Title *</Form.Label>
                                                            <Form.Select
                                                                name="title"
                                                                value={formData.title}
                                                                onChange={handleInputChange}
                                                                required
                                                                className="rounded-1"
                                                            >
                                                                <option value="">Select..</option>
                                                                <option value="Mr">Mr.</option>
                                                                <option value="Mrs">Mrs.</option>
                                                                <option value="Ms">Ms.</option>
                                                                <option value="Dr">Dr.</option>
                                                                <option value="Prof">Prof.</option>
                                                                <option value="Shri">Shri.</option>
                                                                <option value="Hon">Hon.</option>
                                                                <option value="Gov">Gov.</option>
                                                            </Form.Select>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} sm={8} md={9} className="mt-3 mt-sm-0">
                                                        <Form.Group controlId="firstName">
                                                            <Form.Label className="fw-bold">First Name *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="firstName"
                                                                value={formData.firstName}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={50}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* Last Name */}
                                                <Row className="mb-4">
                                                    <Col>
                                                        <Form.Group controlId="surName">
                                                            <Form.Label className="fw-bold">Last Name *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="surName"
                                                                value={formData.surName}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={50}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {/* Company and Email */}
                                                <Row className="mb-4">
                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="companyName">
                                                            <Form.Label className="fw-bold">Company Name *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="companyName"
                                                                value={formData.companyName}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={50}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} md={6} className="mt-3 mt-md-0">
                                                        <Form.Group controlId="email">
                                                            <Form.Label className="fw-bold">Email Address *</Form.Label>
                                                            <Form.Control
                                                                type="email"
                                                                name="email"
                                                                value={formData.email}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={100}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* Password Fields */}
                                                <Row className="mb-4">
                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="password">
                                                            <Form.Label className="fw-bold">Password *</Form.Label>
                                                            <InputGroup>
                                                                <Form.Control
                                                                    type={showPassword ? "text" : "password"}
                                                                    name="password"
                                                                    value={formData.password}
                                                                    onChange={handleInputChange}
                                                                    required
                                                                    maxLength={15}
                                                                    className="rounded-1"
                                                                />
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    onClick={() => setShowPassword(!showPassword)}
                                                                >
                                                                    {showPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                                                                </Button>
                                                            </InputGroup>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} md={6} className="mt-3 mt-md-0">
                                                        <Form.Group controlId="confirmPassword">
                                                            <Form.Label className="fw-bold">Confirm Password *</Form.Label>
                                                            <InputGroup>
                                                                <Form.Control
                                                                    type={showConfirmPassword ? "text" : "password"}
                                                                    name="confirmPassword"
                                                                    value={confirmPassword}
                                                                    onChange={handleConfirmChange}
                                                                    required
                                                                    maxLength={15}
                                                                    className="rounded-1"
                                                                />
                                                                <Button
                                                                    variant="outline-secondary"
                                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                                >
                                                                    {showConfirmPassword ? <AiFillEyeInvisible /> : <AiFillEye />}
                                                                </Button>
                                                            </InputGroup>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {/* Business Category and Phone */}
                                                <Row className="mb-4">
                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="businessCategory">
                                                            <Form.Label className="fw-bold text-white" style={{ fontSize: "0.9rem" }}>
                                                                Select Your Industry *
                                                            </Form.Label>
                                                            <Form.Select
                                                                className="rounded-0"
                                                                name="businessCategory"
                                                                value={formData.businessCategory}
                                                                onChange={handleInputChange}
                                                                required
                                                            >
                                                                <option value="">Select Industry...</option>
                                                                {industries.map((data, index) => (
                                                                    <option key={index} value={data}>
                                                                        {data}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                Please select an industry.
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} md={6} className="mt-3 mt-md-0">
                                                        <Form.Group controlId="phoneNo">
                                                            <Form.Label className="fw-bold">Phone Number *</Form.Label>
                                                            <Form.Control
                                                                type="tel"
                                                                name="phoneNo"
                                                                value={formData.phoneNo}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={12}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* IEC and GST */}
                                                <Row className="mb-4">
                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="inputNumber">
                                                            <Form.Label className="fw-bold">IEC CODE *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="inputNumber"
                                                                value={formData.inputNumber}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={15}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} md={6} className="mt-3 mt-md-0">
                                                        <Form.Group controlId="gstNo">
                                                            <Form.Label className="fw-bold">GST NO. *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="gstNo"
                                                                value={formData.gstNo}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={20}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* Address Fields */}
                                                <Row className="mb-4">
                                                    <Col xs={12}>
                                                        <Form.Group controlId="address1">
                                                            <Form.Label className="fw-bold">Address 1 *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="address1"
                                                                value={formData.address1}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={50}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <Row className="mb-4">
                                                    <Col xs={12} md={6}>
                                                        <Form.Group controlId="address2">
                                                            <Form.Label className="fw-bold">Address 2</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="address2"
                                                                value={formData.address2}
                                                                onChange={handleInputChange}
                                                                maxLength={50}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} md={6} className="mt-3 mt-md-0">
                                                        <Form.Group controlId="country">
                                                            <Form.Label className="fw-bold text-white" style={{ fontSize: "0.9rem" }}>
                                                                Country *
                                                            </Form.Label>
                                                            <Form.Select
                                                                className="rounded-0"
                                                                name="country"
                                                                value={formData.country}
                                                                onChange={handleInputChange}
                                                                required
                                                            >
                                                                <option value="">Select a country...</option>
                                                                {country_list.map((country, index) => (
                                                                    <option key={index} value={country}>
                                                                        {country}
                                                                    </option>
                                                                ))}
                                                            </Form.Select>
                                                            <Form.Control.Feedback type="invalid">
                                                                Please select a country.
                                                            </Form.Control.Feedback>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                {/* City, State, Pincode */}
                                                <Row className="mb-4">
                                                    <Col xs={12} sm={6} md={4}>
                                                        <Form.Group controlId="city">
                                                            <Form.Label className="fw-bold">City *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="city"
                                                                value={formData.city}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={30}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} sm={6} md={4} className="mt-3 mt-sm-0">
                                                        <Form.Group controlId="state">
                                                            <Form.Label className="fw-bold">State *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="state"
                                                                value={formData.state}
                                                                onChange={handleInputChange}
                                                                required
                                                                maxLength={30}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} md={4} className="mt-3 mt-md-0">
                                                        <Form.Group controlId="pinCode">
                                                            <Form.Label className="fw-bold">Pincode *</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                name="pinCode"
                                                                value={formData.pinCode}
                                                                onChange={handleInputChange}
                                                                required
                                                                pattern="[0-9]*"
                                                                minLength={6}
                                                                maxLength={6}
                                                                className="rounded-1"
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                            </div>
                                        </>
                                    </div>
                                    <div className="my-3 text-white" style={{ fontSize: "0.95rem" }}>
                                        <strong>Disclaimer:</strong> Please check the collaborator profiles before booking to make sure it matches your needs. The Chamber will not be held responsible in cases meeting with collaborators does not meet your expectations.
                                    </div>
                                    <div className="my-3">
                                        <Form.Group className="mb-3">
                                            <Form.Check
                                                ref={checkboxRef} // Reference to the checkbox
                                                required
                                                checked={isChecked}
                                                onChange={(e) => setIsChecked(e.target.checked)}
                                                label={
                                                    <span className='text-white' style={{ fontSize: '1.2rem' }}>
                                                        I agree to the{' '}
                                                        <a href="#" onClick={handleShow} style={{ textDecoration: 'underline' }}>
                                                            Terms and Conditions
                                                        </a>
                                                    </span>
                                                }
                                                feedback="You must agree before submitting."
                                                feedbackType="invalid"
                                            />
                                        </Form.Group>

                                        {/* Modal for Terms and Conditions */}
                                        <Modal show={showModal} onHide={handleClose} size="lg" centered>
                                            <Modal.Header
                                                style={{ backgroundColor: "#0b3b5d", color: "white" }}
                                                className="text-white text-center"
                                            >
                                                <Modal.Title className='text-center'>Terms & Conditions</Modal.Title>
                                                <CloseButton variant="white" onClick={() => handleCloseFaq} />
                                            </Modal.Header>

                                            <Modal.Body style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                <p><strong>1. Registration Charges:</strong> The registration charges are solely for the maintenance of the video conferencing platform used for this session and is not the fee for the collaborator expert. The collaborator is joining the session free of cost.</p>

                                                <p><strong>2. Purpose of the Session:</strong>This 30-minute B2B interaction session aims to address basic queries and provide an opportunity for an informative discussion and reliable source to avail future services.</p>

                                                <p><strong>3. Interaction:</strong> This session allows you to connect with an expert collaborator who
                                                    could offer valuable services for your business expansion in the future.</p>

                                                <p><strong>4. Maximizing Utilization:</strong> To make the most of your 30-minute session, please frame
                                                    your questions clearly and concisely, focusing on areas where you need expert insights. Taking too many questions may lead to confusion for both parties.</p>

                                                <p><strong>5. Collaborator - Paid Service Provider:</strong> Please be aware that the collaborator is a paid
                                                    service provider, and the services discussed during the session may be available on
                                                    chargeable basis.</p>

                                                <p><strong>6. Scope of the Session:</strong> This session is not intended for market research, buyer-
                                                    finding, buyer-seller meeting, or detailed business analysis etc. rather it serves as an
                                                    opportunity to connect with someone who could be a valuable resource for entering
                                                    or expanding in chosen market.</p>

                                                <p><strong>7. Mutual Understanding:</strong> Both parties should use this session to understand each
                                                    other&#39;s capabilities and the range of services that can be explored. Discussing the
                                                    scope, terms, and fees of potential services is encouraged.</p>

                                                <p><strong>8. One-to-One Meeting:</strong> The meeting will be conducted as a one-to-one interaction
                                                    between the expert collaborator and the Indian business participant, without any
                                                    interference from us. Our role is to provide the right connection and platform while
                                                    ensuring the privacy of both parties’ business information.</p>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <Button variant="secondary" onClick={handleClose}>
                                                    Close
                                                </Button>
                                                <Button variant="primary" onClick={handleAgree}>
                                                    Agree
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <Button
                                            size="lg"
                                            variant="danger"
                                            className="rounded-1 border-0 fw-medium"
                                            onClick={resetForm}
                                        >
                                            Reset
                                        </Button>
                                        <Button
                                            type="submit"
                                            size='lg'
                                            className="rounded-1 border-0 fw-medium"
                                            disabled={formSuccessful}
                                        >
                                            {!formSuccessful ? "Register" : "Processing..."}
                                        </Button>
                                    </div>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </div>
                <OurPresence />
            </Layout>
        </>
    );
};

export default B2BEventBookings;